<template>
  <div class="ppt-option">
    <div class="ppt-container" :class="[pptHistory.length ? '' : 'full']">
      <div class="container">
        <el-input
          :rows="formData.query ? 22 : 4"
          resize="none"
          class="ppt-query"
          :class="[formData.query ? 'text' : '']"
          type="textarea"
          placeholder="请输入或粘贴ppt主要内容，如：主题：我的毕业设计论文。"
          v-model="formData.query"
          maxlength="10000"
          :show-word-limit="!!formData.query"
          v-if="!formData.file"
          @focus="requestAuthentication"
        >
        </el-input>
        <div v-if="formData.file" class="file-container">
          <div class="file">
            <div class="icon txt" v-if="fileType === 'txt'"></div>
            <div
              class="icon doc"
              v-if="['doc', 'docx'].includes(fileType)"
            ></div>
            <div class="icon md" v-if="fileType === 'md'"></div>
            <div class="info">
              <div class="name">{{ formData.file.name }}</div>
              <div class="size">{{ fileSize }}</div>
            </div>
            <span class="delete-file" data-track-text="删除上传文件" aria-label="删除上传文件" @click="deleteFile">
              <i class="el-icon-error"></i>
            </span>
          </div>
        </div>
        <el-upload
          v-if="!formData.query && !formData.file"
          action
          drag
          :multiple="false"
          ref="fileUpload"
          class="file-btn"
          accept=".doc, .docx, .txt, .md"
          :limit="1"
          :auto-upload="true"
          :before-upload="beforeUpload"
          :http-request="uploadFile"
        >
          <div class="icon">
            <i class="icon-upload"></i>
          </div>
          <div class="text">
            将文件拖到此处或
            <span class="link">点击上传</span>
          </div>
          <div class="type">支持doc、docx、txt、md格式</div>
        </el-upload>
        <div
          class="select-container"
          :class="[pptHistory.length ? '' : 'full']"
        >
          <el-select
            v-model="formData.language"
            placeholder="请选择语言"
            style="width: 130px"
            size="mini"
          >
            <el-option
              v-for="item in languages"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="formData.industrie"
            placeholder="请选择行业"
            style="width: 130px"
            size="mini"
          >
            <el-option
              v-for="item in industries"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="formData.style"
            placeholder="请选择风格"
            style="width: 130px"
            size="mini"
          >
            <el-option
              v-for="item in styles"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="formData.color"
            placeholder="请选择颜色"
            style="width: 130px"
            size="mini"
          >
            <el-option
              v-for="item in colors"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
          <!-- <el-select
            v-model="formData.pageNum"
            placeholder="请选择页数"
            style="width: 110px"
            size="mini"
          >
            <el-option
              v-for="item in pageSizes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="formData.pageSize"
            placeholder="请选择每页数量"
            style="width: 110px"
            size="mini"
          >
            <el-option
              v-for="item in pageNumbers"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select> -->
	          <div class="confirm" data-track-text="挑选PPT模板" aria-label="挑选PPT模板" @click="confirmOpt">挑选模板</div>
        </div>
      </div>
    </div>
    <div class="ppt-history" v-if="pptHistory.length">
      <div
        class="history-item"
        :class="[item.id === currentPPT.id ? 'active' : '']"
        v-for="item in pptHistory"
        :key="item.id"
        @mouseenter="setCurrentPPT(item)"
        @mouseleave="clearCurrentPPT()"
      >
        <div class="item-bg">
          <div class="flex">
            <img class="cover" :src="item.coverImgSrc" />
            <div class="info">
              <div class="title" :title="item.title">
                {{ item.title }}
              </div>
              <div
                class="sub-title"
                v-if="item.id !== currentPPT.id"
                :title="item.subTitle"
              >
                {{ item.subTitle }}
              </div>
              <div v-if="item.id !== currentPPT.id" class="create-time">
                {{ item.createTime }}
              </div>
            </div>
          </div>
          <div
            v-if="item.id === currentPPT.id"
            class="query"
            :title="item.query"
          >
            {{ item.subTitle }}
          </div>
          <i
            class="el-icon-download download"
            v-if="item.id === currentPPT.id"
            data-track-text="下载PPT"
            aria-label="下载PPT"
            @click="downloadPPT(item)"
          ></i>
          <span
            class="delete"
            v-if="item.id === currentPPT.id"
            data-track-text="删除PPT"
            aria-label="删除PPT"
            @click="deletePPT(item)"
          >
            <i class="el-icon-delete"></i>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  // 组件名称
  name: "PPTOption",
  props: {
    userInfo: {
      type: String,
      default: "",
    },
    isAuthenticated: {
      type: Boolean,
      default: false,
    },
  },
  // 变量声明
  data() {
    return {
      pptHistory: [],
      languages: [],
      industries: [],
      styles: [],
      colors: [],
      pageNumbers: [
        {
          value: 10,
          label: "10页",
        },
        {
          value: 15,
          label: "15页",
        },
        {
          value: 20,
          label: "20页",
        },
        {
          value: 25,
          label: "25页",
        },
        {
          value: 30,
          label: "30页",
        },
        {
          value: 35,
          label: "35页",
        },
        {
          value: 40,
          label: "40页",
        },
      ],
      pageSizes: [
        {
          value: 1,
          label: "1页",
        },
        {
          value: 2,
          label: "2页",
        },
        {
          value: 3,
          label: "3页",
        },
        {
          value: 4,
          label: "4页",
        },
        {
          value: 5,
          label: "5页",
        },
        {
          value: 6,
          label: "6页",
        },
        {
          value: 7,
          label: "7页",
        },
        {
          value: 8,
          label: "8页",
        },
        {
          value: 9,
          label: "9页",
        },
        {
          value: 10,
          label: "10页",
        },
      ],
      formData: {
        language: "",
        industrie: "",
        style: "",
        color: "",
        pageNum: "1",
        pageSize: "999",
        model: "SPARK",
        modelVersion: "lite",
        file: null,
        query: "",
      },
      chatId: "",
      sid: "",
      outline: {},
      currentPPT: {},
    };
  },
  computed: {
    templateOptions() {
      return {
        industries: this.industries,
        styles: this.styles,
        colors: this.colors,
      };
    },
    fileType() {
      if (this.formData.file) {
        let fileType = this.formData.file.name.split(".");
        fileType = fileType[fileType.length - 1];
        return fileType;
      }
    },
    fileSize() {
      if (this.formData.file) {
        return this.formatFileSize(this.formData.file.size);
      }
    },
  },
  watch: {},
  // 实例初始化之后,进行数据侦听和事件/侦听器的配置之前同步调用
  beforeCreate() {},
  // 实例创建，挂载阶段未开始，可进行数据初始化
  created() {},
  mounted() {
    this.getPPTTypeList();
    this.getPPTTHistory();
  },
  destroyed() {},
  // 方法
  methods: {
    requestAuthentication() {
      if (this.isAuthenticated) {
        return true;
      }
      this.$emit("getUserStatus");
      return false;
    },
    formatFileSize(bytes, decimals = 2) {
      if (bytes === 0) return "0 Bytes";

      const k = 1024;
      const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return (
        parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)) + " " + sizes[i]
      );
    },
    deleteFile() {
      this.formData.file = null;
    },
    beforeUpload(file) {
      if (!this.requestAuthentication()) {
        return false;
      }
      console.log(123, file);
      const fileType = file.name
        .substring(file.name.lastIndexOf(".") + 1)
        .toLowerCase();
      const extension = ["doc", "docx", "txt", "md"].includes(fileType);
      if (!extension) {
        this.$message.error("暂不支持" + fileType + "文件类型");
      }
      if (file.size === 0) {
        this.$message.error("您上传的文件内容为空！");
        return false;
      }
      const islimit = file.size < 100 * 1024 * 1024;
      if (!islimit) {
        this.$message.error("文件上传大小不能超过100M！");
      }
      let isSuccess = extension && islimit;
      if (isSuccess) {
        this.formData.file = file;
      }
      return isSuccess;
    },
    uploadFile(file) {
      this.formData.query = "";
      console.log(123, this.formData.fileList, file);
    },
    setCurrentPPT(item) {
      this.currentPPT = item;
    },
    clearCurrentPPT() {
      this.currentPPT = {};
    },
    downloadPPT(item) {
      if (item.pptStatus === "done") {
        window.open(item.pptUrl);
      } else {
        this.$message.info("ppt正在生成");
      }
      console.log("downloadPPT", item);
    },
    deletePPT(item) {
      this.$confirm("删除后无法恢复，是否继续删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.$http.delete(`/chatApi/v1/chatPpt/${item.id}`).then((res) => {
            this.$message.success("删除成功");
            this.getPPTTHistory();
          });
        })
        .catch(() => {
          this.$message.info("已取消");
        });
    },
    async confirmOpt() {
      if (!this.requestAuthentication()) {
        return;
      }
      if (!this.formData.language) {
        this.$message.info("请选择生成ppt模板的语言");
        return;
      } else if (!this.formData.industrie) {
        this.$message.info("请选择生成ppt模板的行业");
        return;
      } else if (!this.formData.style) {
        this.$message.info("请选择生成ppt模板的风格");
        return;
      } else if (!this.formData.color) {
        this.$message.info("请选择生成ppt模板的颜色");
        return;
      } else if (!this.formData.pageNum) {
        this.$message.info("请选择生成ppt模板的页数");
        return;
      } else if (!this.formData.pageSize) {
        this.$message.info("请选择生成ppt模板的每页数量");
        return;
      } else if (!this.formData.query && !this.formData.file) {
        this.$message.info("请输入生成ppt文本或上传文件");
        return;
      }
      await this.creatChat();
    },
    creatChat() {
      return this.$http.get("/chatApi/v1/chatPpt/createChat").then((res) => {
        this.chatId = res.data.data;
        this.$emit("confirmOpt", {
          templateOptions: this.templateOptions,
          filters: {
            chatId: this.chatId,
            ...this.formData,
          },
        });
      });
    },
    getPPTTHistory() {
      this.$http.get("/chatApi/v1/chatPpt/history").then((res) => {
        this.pptHistory = res.data.data || [];
        this.$emit("history-state", this.pptHistory.length > 0);
      });
      setTimeout(() => {
        this.getPPTTHistory();
      }, 10000);
    },
    getPPTTypeList() {
      this.$http
        .get("/chatApi/v1/chatPpt/typeSelect", {
          params: {
            model: "SPARK",
          },
        })
        .then((res) => {
          const pptTypeList = res.data.data;
          this.languages = pptTypeList.languages;
          this.industries = pptTypeList.industries;
          this.styles = pptTypeList.styles;
          this.colors = pptTypeList.colors;
        });
    },
  },
};
</script>
<style lang="less" scoped>
.ppt-option {
  margin-left: 10px;
  height: 100%;
  width: 1200px;
  display: flex;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  .ppt-container {
    width: 100%;
    height: 100%;
    flex: 1;
    min-width: 0;
    min-height: 0;
    overflow: hidden;
    border-right: 1px solid var(--border);
    &.full {
      border-right: none;
    }
    .container {
      display: flex;
      flex-direction: column;
      gap: 20px;
      height: 100%;
      padding: 30px;
      box-sizing: border-box;
      overflow-y: auto;
      .file-btn {
        flex: 0 0 auto;
        width: calc(100% - 60px);
        max-width: 720px;
        height: 200px;
        margin: 0 auto;
        cursor: pointer;

        .icon {
          width: 48px;
          height: 48px;
          margin: 0 auto 10px;
          background: var(--primary-alpha-10);
          border-radius: 50%;

          .icon-upload {
            display: inline-block;
            width: 20px;
            height: 20px;
            background: url(../../assets/chat/upload.png) center no-repeat;
            background-size: contain;
            margin-top: 14px;
            filter: invert(42%) sepia(93%) saturate(2476%) hue-rotate(121deg) brightness(95%) contrast(101%);
          }
        }
        .text {
          font-weight: 600;
          font-size: 16px;
          color: var(--foreground);
          line-height: 24px;
          .link {
            color: var(--primary-dark);
            text-decoration: underline;
          }
        }
        .type {
          font-size: 13px;
          color: var(--muted-foreground);
          line-height: 20px;
          margin-top: 8px;
        }
        /deep/.el-upload {
          width: 100%;
          height: 100%;
          .el-upload-dragger {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            background-color: var(--bg-card);
            border: 2px dashed #c0c4cc;
            border-radius: 16px;
            width: 100%;
            height: 100%;
            padding: 28px 40px 24px;
            box-sizing: border-box;
            transition: border-color .15s;
            &:hover {
              border-color: var(--primary);
            }
          }
        }
      }
      .select-container {
        display: flex;
        flex: 0 0 auto;
        flex-wrap: wrap;
        justify-content: center;
        gap: 10px;
        margin-left: 0;
        align-items: center;
        &.full {
          margin-left: 0;
        }
        /deep/.el-input__inner {
          background: var(--bg-subtle);
          border-radius: var(--radius-md);
          border: none;
          height: 40px;
          font-size: 16px;
          color: var(--muted-foreground);
          &::placeholder {
            font-size: 16px;
            color: var(--muted-foreground);
          }
        }
        .confirm {
          width: 100px;
          height: 40px;
          background: var(--primary);
          border-radius: var(--radius-md);
          color: #ffffff;
          line-height: 40px;
          text-align: center;
          cursor: pointer;
          transition: background-color .15s, box-shadow .15s;
          &:hover {
            background: var(--primary-dark);
            box-shadow: var(--shadow-primary);
          }
        }
      }
      .ppt-query {
        /deep/ .el-textarea__inner {
          border: none;
          font-size: 18px;
        }
        /deep/.el-input__count {
          bottom: -28px;
        }
        &.text {
          flex: 1 1 auto;
          min-height: 260px;
          /deep/ .el-textarea__inner {
            height: 100%;
            min-height: 260px;
          }
        }
      }
      .file-container {
        flex: 1 1 auto;
        min-height: 260px;
        .file {
          height: 89px;
          background: var(--bg-card);
          border: 1px solid var(--border);
          border-radius: var(--radius-md);
          position: relative;
          display: flex;
          align-items: center;
          .delete-file {
            position: absolute;
            top: -8px;
            right: -4px;
            color: var(--disabled-text);
            cursor: pointer;
          }
          .info {
            .name {
              font-size: 16px;
              color: var(--foreground-secondary);
              line-height: 24px;
            }
            .size {
              font-size: 14px;
              color: var(--muted-foreground);
              line-height: 24px;
            }
          }
          .icon {
            width: 46px;
            height: 46px;
            margin: 0 20px;
          }
          .txt {
            background: url(../../assets/chat/txt.png) center no-repeat;
            background-size: contain;
          }
          .doc {
            background: url(../../assets/chat/doc.png) center no-repeat;
            background-size: contain;
          }
          .md {
            background: url(../../assets/chat/md.png) center no-repeat;
            background-size: contain;
          }
        }
      }
    }
  }
  .ppt-history {
    width: 340px;
    height: 100%;
    min-height: 0;
    overflow: auto;
    .history-item {
      height: 88px;
      margin-top: 18px;
      margin-left: 10px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      &.active {
        background: var(--bg-subtle);
        border-radius: var(--radius-md);
        height: 140px;
        .flex {
          background: var(--bg-card);
          border-radius: var(--radius-md);
          margin: 6px;
          .cover {
            width: 68px;
            height: 36px;
          }
          .title {
            font-weight: 600;
            font-size: 18px;
            color: var(--foreground-secondary);
            line-height: 56px;
          }
        }
        .query {
          font-size: 14px;
          color: var(--muted-foreground);
          line-height: 20px;
          width: 230px;
          margin: 18px 0 20px 10px;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      }
      .item-bg {
        .flex {
          display: flex;
        }
      }
      .cover {
        width: 142px;
        height: 76px;
        border-radius: 6px;
        margin: 10px 12px 10px 10px;
      }
      .info {
        flex: 1;
        .title {
          font-size: 16px;
          color: var(--foreground-secondary);
          line-height: 24px;
          overflow: hidden; /* 隐藏溢出内容 */
          white-space: nowrap; /* 禁止文本换行 */
          text-overflow: ellipsis; /* 显示省略符号 */
          width: 140px;
        }
        .sub-title {
          font-size: 14px;
          color: var(--disabled-text);
          line-height: 20px;
          margin-top: 24px;
          overflow: hidden; /* 隐藏溢出内容 */
          white-space: nowrap; /* 禁止文本换行 */
          text-overflow: ellipsis; /* 显示省略符号 */
          width: 140px;
        }
        .create-time {
          font-size: 14px;
          color: var(--disabled-text);
          line-height: 20px;
        }
      }
      .download {
        width: 16px;
        height: 16px;
        position: absolute;
        color: var(--muted-foreground);
        bottom: 32px;
        right: 16px;
        cursor: pointer;
      }
      .delete {
        width: 16px;
        height: 16px;
        position: absolute;
        color: var(--muted-foreground);
        top: 16px;
        right: 16px;
        cursor: pointer;
      }
    }
  }
}

/* AI PPT 参数页移动布局：表单全宽，历史记录移到下方。 */
@media (max-width: 768px) {
  .ppt-option {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    min-width: 0;
    min-height: 0;
    margin-left: 0;
    overflow-x: hidden;
    overflow-y: auto;

    .ppt-container {
      flex: 1 0 580px;
      width: 100%;
      height: auto;
      min-width: 0;
      min-height: 580px;
      overflow: hidden;
      border-right: 0;

      .container {
        width: 100%;
        height: 100%;
        min-width: 0;
        min-height: 580px;
        gap: 12px;
        padding: 14px 12px;
        overflow-x: hidden;
        overflow-y: auto;
        box-sizing: border-box;

        .ppt-query {
          width: 100%;
          min-width: 0;

          /deep/ .el-textarea__inner {
            width: 100%;
            min-height: 100px;
            padding: 10px 12px;
            box-sizing: border-box;
            font-size: 15px;
            line-height: 22px;
          }

          &.text {
            min-height: 220px;

            /deep/ .el-textarea__inner {
              min-height: 220px;
            }
          }
        }

        .file-btn {
          flex: 1 1 240px;
          box-sizing: border-box;
          width: 100%;
          max-width: none;
          min-height: 220px;
          margin: 0;

          .icon {
            width: 42px;
            height: 42px;
            margin-bottom: 8px;

            .icon-upload {
              margin-top: 11px;
            }
          }

          .text {
            padding: 0 10px;
            font-size: 15px;
          }

          .type {
            margin-top: 10px;
            padding: 0 10px;
            font-size: 13px;
          }
        }

        .file-container {
          width: 100%;
          min-width: 0;
          min-height: 220px;

          .file {
            width: 100%;
            min-width: 0;

            .info {
              min-width: 0;

              .name {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
          }
        }

        .select-container {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          align-items: center;
          gap: 8px;
          width: 100%;
          min-width: 0;

          /deep/ .el-select {
            width: 100% !important;
            min-width: 0;
          }

          /deep/ .el-input__inner {
            width: 100%;
            height: 38px;
            padding-right: 24px;
            padding-left: 10px;
            font-size: 14px;

            &::placeholder {
              font-size: 14px;
            }
          }

          .confirm {
            grid-column-start: 1;
            grid-column-end: -1;
            width: 100%;
            height: 40px;
            line-height: 40px;
          }
        }
      }
    }

    .ppt-history {
      position: relative;
      flex: 0 0 240px !important;
      width: 100% !important;
      height: 240px !important;
      min-width: 0;
      min-height: 0;
      padding-top: 36px;
      overflow-x: hidden;
      overflow-y: auto;
      border-top: 8px solid var(--bg-page);
      box-sizing: border-box;

      &::before {
        content: "历史记录";
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        height: 36px;
        padding: 0 12px;
        border-bottom: 1px solid var(--border);
        background: var(--bg-card);
        box-sizing: border-box;
        color: var(--foreground-secondary);
        font-size: 14px;
        font-weight: 600;
        line-height: 36px;
      }

      .history-item {
        width: calc(100% - 20px);
        margin: 10px 10px 0;
        box-sizing: border-box;
      }
    }
  }
}
</style>
